import React from "react";
import Picture from "@/Components/Picture";
import Link from "@/Layouts/Link";
import "@/Scss/Site/Product/otherModels.scss";

const OtherModels = (props) => {
    const {product = {}} = props;
    const {productsModel = []} = product;

    if (productsModel.length === 0) return null;

    return (
        <div className={`otherModels`}>
            <p className={`otherModels__title`}>Другие варианты модели</p>
            <div className={`otherModels__body`}>
                {productsModel.map((product, i) => {
                    return (
                        <Link key={i} href={`/catalog/product/${product.article}`} className={`otherModels__item`}>
                            <Picture src={product.img} alt={product.h1} />
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default OtherModels;
